import PropTypes from 'prop-types'
import { Link } from 'react-router'
import classNames from 'classnames'
import Tappable from 'react-tappable'
import { Media } from 'react-bootstrap'
import { helloBabyPostPath } from 'lib/urls'
import ImageWithPlaceholderColor from 'components/image-with-placeholder-color'

import css from './post-teaser.scss'

const PostTeaser = ({ bodyClassName, isResponsive, post, index }) => {
  const { url, thumbnailUrl } = post.featuredImage

  const imageClasses = classNames('hover-overlay hover-lighten', {
    [css.postThumbnailMdResponsive]: isResponsive,
    [css.postThumbnailSm]: !isResponsive,
  })

  return (
    <Tappable
      className={css.postTeaser}
      classes={{ active: css.active }}
      component="div"
    >
      <Media>
        <Media.Left>
          <div className={imageClasses}>
            {post.featuredImage && (
              <ImageWithPlaceholderColor
                alt={post.title}
                aspectHeight={2}
                aspectWidth={3}
                colorIndex={index}
                data-pin-nopin="true"
                src={thumbnailUrl.includes('babylist') ? thumbnailUrl : url}
              />
            )}
          </div>
        </Media.Left>

        <Media.Body className={classNames(bodyClassName, 'pvn')}>
          <Link
            className={classNames(css.postTitle, 'media-heading', 'text-body')}
            to={helloBabyPostPath(post.slug)}
          >
            {post.title}
          </Link>
          {isResponsive && <p className="serif mbn">{post.teaser}</p>}
        </Media.Body>
      </Media>
    </Tappable>
  )
}

PostTeaser.propTypes = {
  bodyClassName: PropTypes.string,
  isResponsive: PropTypes.bool.isRequired,
  post: PropTypes.shape({
    id: PropTypes.string.isRequired,
    featuredImage: PropTypes.shape({
      description: PropTypes.string,
      thumbnailUrl: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
    revision: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    teaser: PropTypes.string,
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  index: PropTypes.number,
}

PostTeaser.defaultProps = {
  isResponsive: true,
}

export default PostTeaser
